export const formatData = (formValues) => {
  return `\n\n${Object.entries(formValues)
    .map(([key, value]) =>
      key === "title" ? `\n\n\n${value}` : `\n\n${key}: \n${value}`
    )
    .join("")}`;
};
